import { TextBlock } from '../interfaces/textEditor.interface';
import { deleteAllImagesInDraft } from './deleteAllImagesInDraft';
import { deleteDraftFolder } from './deleteContentBlockFromS3';

interface DeletionResults {
  imageResults: {
    success: string[];
    failed: Array<{ url: string; key: string; error: string }>;
  };
  contentResults: {
    success: boolean;
    key: string;
    error?: string;
  };
}

/**
 * Deletes all content from a draft (images + content blocks folder)
 *
 * @param textBlocks - The text blocks containing potential images
 * @param userId - The user ID
 * @param draftId - The draft ID
 */
export const deleteAllContentInDraft = async (
  textBlocks: TextBlock[],
  userId: string,
  draftId: string,
  _contentRef?: string, // kept for backwards compatibility but not used
): Promise<DeletionResults> => {
  // First, delete all images from image blocks
  const imageResults = await deleteAllImagesInDraft(textBlocks);

  // Then, delete the entire draft content folder (content.json + versions/)
  const folderKey = `${userId}/${draftId}/`;
  const contentResults = {
    success: false,
    key: folderKey,
    error: undefined as string | undefined,
  };

  try {
    await deleteDraftFolder(userId, draftId);
    contentResults.success = true;
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    console.error(`Failed to delete draft folder ${folderKey}:`, error);
    contentResults.error = errorMessage;
  }

  return { imageResults, contentResults };
};
